/* eslint-disable promise/param-names */
import {
  AUTH_REQUEST,
  AUTH_LOGIN_WITH_CODE,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT
} from '../actions/auth';

import firebase from 'firebase/app'
import 'firebase/auth';

const state = { 
  isAuthenticated: false,
};

const getters = {
  isAuthenticated: state => state.isAuthenticated,
};

const actions = {
  [AUTH_REQUEST]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(args.email, args.password)
        .then((response) => {
          commit('AUTH_SUCCESS', response.user);
          resolve(response.user);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  [AUTH_LOGOUT]: ({commit}) => {
    commit(AUTH_REQUEST)
    
    return new Promise((resolve) => {
      commit(AUTH_LOGOUT);

      firebase.auth().signOut().then(() => {
        resolve()
      })
    })
  },

  'checkAuth': ({commit}) => {

    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          commit(AUTH_SUCCESS)
          resolve('authorized')
        } else {
          commit(AUTH_ERROR)
          commit(AUTH_LOGOUT)

          reject('unauthorized')
        }
      })
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },

  [AUTH_SUCCESS]: (state) => {
    state.status = 'success'
    state.isAuthenticated = true
  },

  [AUTH_ERROR]: (state) => {
    state.status = 'error'
  },
  [AUTH_LOGOUT]: (state) => {
    state.isAuthenticated = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
